// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__36ooh","productName":"Table_productName__2YqDc"};